import { Notification } from 'rsuite'

const open = (funcName, { ...props }) => {
  Notification[funcName]({
    ...props,
  })
}

export default {
  open,
}
